import { ThemeOption } from "@/types/workspace";

export const themes = [
  {
    label: "Classic Blue",
    key: ThemeOption.CLASSIC_BLUE,
    primary: "bg-blue-600",
    secondary: "bg-blue-200",
  },
  {
    label: "Forest Green",
    key: ThemeOption.FOREST_GREEN,
    primary: "bg-green-600",
    secondary: "bg-green-200",
  },
  {
    label: "Royal Purple",
    key: ThemeOption.ROYAL_PURPLE,
    primary: "bg-purple-600",
    secondary: "bg-purple-200",
  },
  {
    label: "Sunset Orange",
    key: ThemeOption.SUNSET_ORANGE,
    primary: "bg-orange-600",
    secondary: "bg-orange-200",
  },
  {
    label: "Ocean Teal",
    key: ThemeOption.OCEAN_TEAL,
    primary: "bg-teal-600",
    secondary: "bg-teal-200",
  },
  {
    label: "Ruby Red",
    key: ThemeOption.RUBY_RED,
    primary: "bg-red-600",
    secondary: "bg-red-200",
  },
];
